"use strict";

var _regeneratorRuntime = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var clipboard = tslib_1.__importStar(require("clipboard-polyfill/text"));

var styles = tslib_1.__importStar(require("./Map.style"));

var __1 = require("../..");

var Button_1 = tslib_1.__importDefault(require("../../Buttons/Button"));

function Map(_ref) {
  var className = _ref.className,
      address = _ref.address,
      mapImageUrl = _ref.mapImageUrl,
      mapSearchUrl = _ref.mapSearchUrl,
      onClickCopy = _ref.onClickCopy,
      onClickMap = _ref.onClickMap;
  var addressRef = react_1.useRef(null);

  function handleClickCopyClipboard() {
    return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var copyText;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(addressRef && addressRef.current)) {
                _context.next = 11;
                break;
              }

              copyText = addressRef.current.innerText;
              _context.prev = 2;
              _context.next = 5;
              return clipboard.writeText(copyText);

            case 5:
              __1.createToast('주소가 클립보드에 복사되었습니다.', {
                color: 'general',
                position: 'top',
                timeoutMs: 5000
              });

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);

              __1.createToast('주소 복사에 실패했습니다.', {
                color: 'general',
                position: 'top',
                timeoutMs: 5000
              });

            case 11:
              onClickCopy && onClickCopy();

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));
  }

  function handleViewMapButtonClick() {
    onClickMap && onClickMap();
    window.open(mapSearchUrl);
  }

  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className
  }, {
    children: [jsx_runtime_1.jsx("div", Object.assign({
      css: styles.wrapper
    }, {
      children: jsx_runtime_1.jsx("div", {
        css: styles.mapImage,
        onClick: handleViewMapButtonClick,
        style: {
          backgroundImage: "url(".concat(mapImageUrl, ")")
        }
      }, void 0)
    }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.addressContainer
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({
        ref: addressRef,
        css: styles.address
      }, {
        children: address
      }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.buttonGroups
      }, {
        children: [jsx_runtime_1.jsxs(Button_1.default, Object.assign({
          size: "medium",
          type: "outline",
          onClick: handleClickCopyClipboard
        }, {
          children: [jsx_runtime_1.jsx(__1.Icon, {
            name: "ic_copy_md_gray_700",
            alt: "copy clipboard"
          }, void 0), "\uC8FC\uC18C\uBCF5\uC0AC"]
        }), void 0), jsx_runtime_1.jsxs(Button_1.default, Object.assign({
          size: "medium",
          type: "secondary",
          onClick: handleViewMapButtonClick
        }, {
          children: [jsx_runtime_1.jsx(__1.Icon, {
            name: "ic_map_md_line_blue_500",
            alt: "view map"
          }, void 0), "\uC9C0\uB3C4\uBCF4\uAE30"]
        }), void 0)]
      }), void 0)]
    }), void 0)]
  }), void 0);
}

exports.default = Map;